<template>
  <div>
    <livechat-search v-model="showSearch"></livechat-search>
    <div v-if="$store.getters.getPackage == 'premium'" id="livechat">
      <div v-show="view == 'users'">
        <div id="chattype">
          <template v-if="searchlist.length == 0">
            <livechat-tab
              :newchatnotify="newchatnotify"
              @onsearch="showSearch = true"
            ></livechat-tab>
          </template>
          <template v-else>
            <livechat-search-box @onsearch="showSearch = true"></livechat-search-box>
            <v-divider></v-divider>
          </template>
        </div>

        <div
          :style="{
            'margin-top': !searchlist ? '84px' : '0'
          }"
        >
          <users
            v-if="$store.state.livechat.type == 'admin'"
            v-model="selectedUser"
            :app="$store.state.livechat.app"
            :usersearching="usersearching"
            :filter="filter"
            :type="'admin'"
            :is-mobile="true"
            @onChangeFilter="handleChangeFilter"
            @onClickUser="onClickUser"
          ></users>
          <users
            v-if="$store.state.livechat.type == 'bot'"
            v-model="selectedUser"
            :usersearching="usersearching"
            :app="$store.state.livechat.app"
            :filter="filter"
            :type="'bot'"
            :is-mobile="true"
            @onChangeFilter="handleChangeFilter"
            @onClickUser="onClickUser"
          ></users>
        </div>
      </div>
      <div v-if="view == 'chatbox'">
        <chatbox
          :key="selectedUser.userid"
          v-model="selectedUser"
          :newchatnotify="newchatnotify"
          :is-mobile="true"
          @endSession="onEndSession"
          @onClose="onCloseChatbox"
          @onShowTool="onShowTool"
        ></chatbox>

        <v-navigation-drawer v-model="showTool" right fixed temporary>
          <v-layout>
            <v-flex>
              <v-btn fab small flat class="extra-small" @click="showTool = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn
                v-if="
                  selectedUser.context == 'contactadmin' &&
                  selectedBot.pageid != '102052945584054' &&
                  selectedBot.pageid != '106855151601601'
                "
                small
                outline
                @click="endSession"
                >{{ $t('Switch to bot') }}</v-btn
              >
              <v-btn
                v-else-if="selectedUser.context != 'contactadmin'"
                small
                outline
                @click="openSession"
                >{{ $t('Switch to admin') }}</v-btn
              >
            </v-flex>
          </v-layout>
          <template v-if="selectedUser">
            <livechat-chattool :selected-user="selectedUser"></livechat-chattool>
          </template>
        </v-navigation-drawer>
      </div>
    </div>
    <div v-else style="position: relative">
      <v-premium-plan-popup
        v-if="$store.getters.getPackage != 'premium'"
        background-color="white"
        style="border-radius: 10px; min-height: 100vh; height: 100%"
      ></v-premium-plan-popup>
    </div>
    <audio
      v-show="false"
      id="noti_sound"
      src="/static/sound/noti_sound.m4a"
      type="audio/x-m4a"
      preload="auto"
      controls
    ></audio>
  </div>
</template>

<script>
import Livechat from './Livechat.js'
import LivechatCustomers from './livechat-customers'
export default {
  components: {
    LivechatCustomers
  },
  mixins: [Livechat],
  data() {
    return {
      showTool: false,
      view: 'users',
      chattooltype: 'customer'
    }
  },
  methods: {
    onShowTool: function () {
      this.showTool = !this.showTool
    },
    onCloseChatbox: function () {
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.view = 'users'
    },
    onClickUser: function () {
      this.view = 'chatbox'
    },
    onEndSession: function () {
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.$store.dispatch('updateLivechatUser', null)
      this.$store.dispatch('forceLoadLastestUsers')
      this.showTool = false
      this.view = 'users'
    },
    onOpenSession: function () {
      this.type = 'admin'
      var user = this.$store.state.livechat.currentUser
      user.type = this.type
      this.$store.dispatch('updateLivechatUser', user)
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
      this.showTool = false
      this.view = 'users'
    },

    onResizeToolList: function () {
      var vm = this
      vm.$nextTick(function () {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatMobile.vue